import React from 'react';

import { styles } from './styles';

export default function TagsComponent({ tags, isMediumSize }) {
  const classes = styles();

  return (
    <div className={classes.tags}>
      {tags.map((tag) => (
        <span
          key={tag.name}
          className={`${classes.tagChip} ${isMediumSize ? classes.tagChipMedium : ''}`}
          style={{
            backgroundColor: tag.bgColorCode,
            color: tag.fgColorCode,
            border: 0,
          }}
        >
          {tag.name}
        </span>
      ))}
    </div>
  );
}
